import React from 'react';
import {
  Amount_entered,
  amount_in_multiplies, Android,
  Change_currency, Empty_field_with_placeholder, enter_between,
  Equivalent_to_KHR, Error_message,
  getSubCategoryId, Multiple_accounts,
  Multiple_currencies, number_0_00, number_35_00, number_50_00,
} from '../../../utils/DictionaryManagementUtils';
import ChangeCurrencyAmountFP from '../FullPagesComponents/Services/Amount/ChangeCurrencyAmountFP';
import AmountMenuFP from '../FullPagesComponents/Services/Amount/AmountMenuFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

const EnterAmountDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  amount,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const isAnd = simPlatform === Android;
  const showConvert = amount.enable_additional_instruction;
  const { colors } = globJSON.configurations.theme;

  //= ====================================================================
  return (
    <SimulatorsViewerArrangement
      simPlatform={simPlatform}
    >
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_0_00}
        showConvert={showConvert && enter_between}
        amountColor={colors.secondary_font_color}
        strTitle={Empty_field_with_placeholder}
        slideshowRefs={slideshowRefs}
      />
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_50_00}
        showConvert={showConvert && enter_between}
        IconBackgroundColor={colors.primary_cta_color}
        strTitle={Amount_entered}
        slideshowRefs={slideshowRefs}
      />
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_50_00}
        showConvert={showConvert && enter_between}
        IconBackgroundColor={colors.primary_cta_color}
        showExpendBox
        strTitle={Multiple_accounts}
        slideshowRefs={slideshowRefs}
      />
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_35_00}
        showConvert={amount_in_multiplies}
        showExpendBox
        isErroLine
        strTitle={Error_message}
        slideshowRefs={slideshowRefs}
      />
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_50_00}
        showConvert={showConvert && Equivalent_to_KHR}
        IconBackgroundColor={colors.primary_cta_color}
        showExpendBox
        strTitle={Multiple_currencies}
        enable_select_currency
        slideshowRefs={slideshowRefs}
      />
      <ChangeCurrencyAmountFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        isAnd={isAnd}
        subCategoryId={subCategoryId}
        strTitle={Change_currency}
        slideshowRefs={slideshowRefs}
      />
    </SimulatorsViewerArrangement>
  );
};

export default EnterAmountDF;
